import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BlurModal from '../blur-modal';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';

class comClass extends PureComponent {

  constructor(props) {
    super(props);

    this.closeAlert = this.closeAlert.bind(this);

  }

  closeAlert(){
    this.props.closeAlertBox();
  }

  render() {
    const { i18n: {messages}} = this.props;
    return (

      <BlurModal
        visible={this.props.screen.alert.show}
        doneVisible={false}
        title={messages['app.auth.logout.header']}
        onDone={()=>this.closeAlert()}
        >

        <div className="row">
          <div className="columns small-12 text-center pad-left-20 pad-right-20">
            <div className="alertbox">
              <div tabIndex={0} className="message alertFocus"> {this.props.screen.alert.message} </div>


              <div className="row">
                <div className="columns small-12 medium-12 large-12">
                  <Button testID="btn_alertModal_alert_test" id="alertWindow" onClick={()=>this.closeAlert()} className="button small expand"> {messages['app.rmcallback.okMsg']}</Button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </BlurModal>

    );
  }
}


export default createContainer({
  $queries: {
    closeAlertBox : { $call: 'screen.alert.close' },
    screen:{
      alert:{
        show: true,
        message: true
      }
    },
    i18n: {
      messages: true,
    }
  },
})(comClass);



